import { ManzanaPolicy } from "./ManzanaPolicy";

export const manzanaPolicy = new ManzanaPolicy()